import { render, staticRenderFns } from "./EditAttributes.vue?vue&type=template&id=40e681be&scoped=true&"
import script from "./EditAttributes.vue?vue&type=script&lang=js&"
export * from "./EditAttributes.vue?vue&type=script&lang=js&"
import style0 from "./EditAttributes.vue?vue&type=style&index=0&id=40e681be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e681be",
  null
  
)

export default component.exports